class RingtonePlayer {
  private audioCtx: AudioContext | null = null;
  private intervalId: any = null;
  private currentOsc1: OscillatorNode | null = null;
  private currentOsc2: OscillatorNode | null = null;
  private currentGain: GainNode | null = null;

  public start() {
    if (this.intervalId || this.audioCtx) {
      return; // Already playing
    }

    const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContextClass) {
      console.warn("Web Audio API not supported in this browser");
      return;
    }

    this.audioCtx = new AudioContextClass();

    const playRing = () => {
      if (!this.audioCtx) return;

      // Handle suspended state due to browser autoplay policy
      if (this.audioCtx.state === "suspended") {
        this.audioCtx.resume();
      }

      try {
        const osc1 = this.audioCtx.createOscillator();
        const osc2 = this.audioCtx.createOscillator();
        const gainNode = this.audioCtx.createGain();

        osc1.frequency.value = 440;
        osc2.frequency.value = 480;

        // Set gain to 0 initially
        gainNode.gain.setValueAtTime(0, this.audioCtx.currentTime);
        // Linear fade in over 0.05 seconds
        gainNode.gain.linearRampToValueAtTime(0.15, this.audioCtx.currentTime + 0.05);
        // Hold for 1.95 seconds, then fade out over 0.05 seconds
        gainNode.gain.setValueAtTime(0.15, this.audioCtx.currentTime + 1.95);
        gainNode.gain.linearRampToValueAtTime(0, this.audioCtx.currentTime + 2.0);

        osc1.connect(gainNode);
        osc2.connect(gainNode);
        gainNode.connect(this.audioCtx.destination);

        osc1.start();
        osc2.start();

        osc1.stop(this.audioCtx.currentTime + 2.0);
        osc2.stop(this.audioCtx.currentTime + 2.0);

        this.currentOsc1 = osc1;
        this.currentOsc2 = osc2;
        this.currentGain = gainNode;
      } catch (err) {
        console.error("Error playing ringtone tone:", err);
      }
    };

    // Play immediately, then repeat every 6 seconds (2s ring, 4s silence)
    playRing();
    this.intervalId = setInterval(playRing, 6000);
  }

  public stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    try {
      if (this.currentOsc1) {
        this.currentOsc1.stop();
        this.currentOsc1.disconnect();
        this.currentOsc1 = null;
      }
      if (this.currentOsc2) {
        this.currentOsc2.stop();
        this.currentOsc2.disconnect();
        this.currentOsc2 = null;
      }
      if (this.currentGain) {
        this.currentGain.disconnect();
        this.currentGain = null;
      }
    } catch (e) {
      // Ignore errors from stopping already-stopped nodes
    }

    if (this.audioCtx) {
      if (this.audioCtx.state !== "closed") {
        this.audioCtx.close().catch((err) => console.warn("Error closing AudioContext:", err));
      }
      this.audioCtx = null;
    }
  }
}

export const ringtonePlayer = new RingtonePlayer();
